import { render, staticRenderFns } from "./BIcon.vue?vue&type=template&id=175def7d&scoped=true&"
import script from "./BIcon.vue?vue&type=script&lang=js&"
export * from "./BIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175def7d",
  null
  
)

export default component.exports